// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_Jrd","cls2":"CollapsedActivityPreview-cls2_Gj_ CollapsedActivityPreview-cls1_Jrd"};